import type { copilot as en } from "../en/copilot";
import type { Messages } from "../types";

export const copilot: Messages<typeof en> = {
  name: "المساعد",
  orb: {
    open: "اسأل المساعد",
    hint: "اسأل",
    hold: "اضغط مطوّلاً على المسافة للتحدث",
  },
  overlay: {
    title: "المساعد",
    placeholder: "اسأل أو ابحث أو اطلب ما تريد…",
    placeholderContext: "اسأل عن {{what}}…",
    send: "اسأل",
    stop: "إيقاف",
    close: "إغلاق المساعد",
    fullscreen: "فتح بملء الشاشة",
    exitFullscreen: "العودة إلى النافذة العائمة",
    newSession: "جلسة جديدة",
    sessions: "الجلسات",
    noSessions: "ستظهر جلساتك هنا.",
    deleteSession: "حذف الجلسة",
    deleted: "حُذفت الجلسة",
    hello: "أهلاً {{name}}. ماذا نراجع اليوم؟",
    helloHint: "أقرأ تعليقاتك ورسائلك ومنشوراتك وتحليلاتك وأعرضها بطرق عرض حيّة يمكن تثبيتها. أنا أقترح التغييرات فقط، وأنت تراجع كل تغيير وتوافق عليه.",
    disclaimer: "قد تخطئ الإجابات. كل تغيير ينتظر موافقتك.",
    you: "أنت",
    error: "لم يستطع المساعد إكمال هذه الإجابة.",
    retry: "حاول مرة أخرى",
    cancelled: "تم الإيقاف.",
    loadingSession: "جارٍ فتح الجلسة…",
    shortcut: "{{key}} J للفتح · Esc للإغلاق",
    thinking: "يفكّر…",
  },
  voice: {
    talk: "تحدّث مع المساعد",
    stop: "إيقاف الاستماع",
    listening: "أستمع… انقر على الكرة عند الانتهاء",
    holding: "أستمع… اترك زر المسافة للإرسال",
    transcribing: "أفهم ما قلت…",
    speaking: "أتحدث: انقر على الكرة للمقاطعة",
    noSpeech: "لم أسمع شيئاً. حاول مرة أخرى.",
    micDenied: "تم رفض الوصول إلى الميكروفون. اسمح به من إعدادات الموقع في المتصفح.",
    mute: "قراءة الإجابات بصوت عالٍ",
  },
  context: {
    label: "السياق",
    page: "هذه الصفحة",
    post: "هذا المنشور",
    comment: "هذا التعليق",
    conversation: "هذه المحادثة",
    contact: "هذا الشخص",
    account: "هذا الحساب",
    dashboard: "لوحة المعلومات هذه",
    job: "هذه المهمة",
    rule: "هذه القاعدة",
    publication: "هذا المنشور",
    selection_zero: "{{count}} محدد",
    selection_one: "{{count}} محدد",
    selection_two: "{{count}} محدد",
    selection_few: "{{count}} محدد",
    selection_many: "{{count}} محدد",
    selection_other: "{{count}} محدد",
    ignore: "لا تستخدم سياق الصفحة",
    use: "استخدم سياق الصفحة",
  },
  selection: {
    comment_zero: "التعليقات المحددة: {{count}}",
    comment_one: "التعليقات المحددة: {{count}}",
    comment_two: "التعليقات المحددة: {{count}}",
    comment_few: "التعليقات المحددة: {{count}}",
    comment_many: "التعليقات المحددة: {{count}}",
    comment_other: "التعليقات المحددة: {{count}}",
    conversation_zero: "المحادثات المحددة: {{count}}",
    conversation_one: "المحادثات المحددة: {{count}}",
    conversation_two: "المحادثات المحددة: {{count}}",
    conversation_few: "المحادثات المحددة: {{count}}",
    conversation_many: "المحادثات المحددة: {{count}}",
    conversation_other: "المحادثات المحددة: {{count}}",
    contact_zero: "الأشخاص المحددون: {{count}}",
    contact_one: "الأشخاص المحددون: {{count}}",
    contact_two: "الأشخاص المحددون: {{count}}",
    contact_few: "الأشخاص المحددون: {{count}}",
    contact_many: "الأشخاص المحددون: {{count}}",
    contact_other: "الأشخاص المحددون: {{count}}",
    approval_zero: "الموافقات المحددة: {{count}}",
    approval_one: "الموافقات المحددة: {{count}}",
    approval_two: "الموافقات المحددة: {{count}}",
    approval_few: "الموافقات المحددة: {{count}}",
    approval_many: "الموافقات المحددة: {{count}}",
    approval_other: "الموافقات المحددة: {{count}}",
    other_zero: "العناصر المحددة: {{count}}",
    other_one: "العناصر المحددة: {{count}}",
    other_two: "العناصر المحددة: {{count}}",
    other_few: "العناصر المحددة: {{count}}",
    other_many: "العناصر المحددة: {{count}}",
    other_other: "العناصر المحددة: {{count}}",
    remove: "إزالة التحديد",
    selectPerson: "تحديد @{{name}}",
    hint: "اسأل عن العناصر المحددة، مثل \"أخفِ هذه\"",
  },
  steps: {
    route: "أفهم السؤال",
    compose: "أصوغ الإجابة",
    repair: "أرتّب الإجابة",
    tool: "أستخدم {{tool}}",
    found_zero: "النتائج: {{count}}",
    found_one: "النتائج: {{count}}",
    found_two: "النتائج: {{count}}",
    found_few: "النتائج: {{count}}",
    found_many: "النتائج: {{count}}",
    found_other: "النتائج: {{count}}",
  },
  tools: {
    search_comments: "أبحث في التعليقات",
    list_comments: "أجمع التعليقات",
    list_deleted: "أبحث عن العناصر المحذوفة",
    get_post: "أفتح المنشور",
    list_posts: "أجمع المنشورات",
    post_insights: "أقرأ إحصاءات المنشور",
    account_analytics: "أحسب الأرقام",
    best_times: "أبحث عن أفضل الأوقات",
    list_conversations: "أقرأ المحادثات",
    get_contact: "أبحث عن الشخص",
    list_people: "أرتّب المعلّقين",
    list_rules: "أقرأ القواعد",
    simulate_rule: "أجرّب القاعدة",
    list_jobs: "أتحقق من المهام",
    sync_health: "أتحقق من سلامة المزامنة",
    search_knowledge: "أبحث في قاعدة معرفتك",
    describe_datasets: "أقرأ دليل البيانات",
    calendar_events: "أراجع التقويم",
    list_posts_with_comments: "أعرض المنشورات مع تعليقاتها",
    propose_action: "أجهّز اقتراحاً",
  },
  blocks: {
    live: "مباشر",
    snapshot: "لقطة",
    pin: "تثبيت في لوحة معلومات",
    pinTo: "تثبيت في…",
    pinHome: "الرئيسية",
    pinNew: "لوحة معلومات جديدة",
    pinNewName: "اسم اللوحة",
    pinNewDefault: "تثبيتات المساعد",
    pinCreate: "إنشاء وتثبيت",
    pinned: "تم التثبيت في {{name}} ويبقى محدّثاً مباشرة.",
    pinOpen: "فتح",
    pinFailed: "تعذّر تثبيت هذا العنصر.",
    comments_zero: "لا تعليقات",
    comments_one: "تعليق واحد",
    comments_two: "تعليقان",
    comments_few: "{{count}} تعليقات",
    comments_many: "{{count}} تعليقًا",
    comments_other: "{{count}} تعليق",
    posts_zero: "لا منشورات",
    posts_one: "منشور واحد",
    posts_two: "منشوران",
    posts_few: "{{count}} منشورات",
    posts_many: "{{count}} منشورًا",
    posts_other: "{{count}} منشور",
    conversations_zero: "لا محادثات",
    conversations_one: "محادثة واحدة",
    conversations_two: "محادثتان",
    conversations_few: "{{count}} محادثات",
    conversations_many: "{{count}} محادثة",
    conversations_other: "{{count}} محادثة",
    showing: "عرض {{shown}} من {{total}}",
    openInbox: "فتح في صندوق الوارد",
    openPerson: "فتح الملف الشخصي",
    noData: "لا يوجد ما يطابق الآن.",
    loading: "جارٍ التحميل…",
    unread_zero: "{{count}} غير مقروءة",
    unread_one: "{{count}} غير مقروءة",
    unread_two: "{{count}} غير مقروءة",
    unread_few: "{{count}} غير مقروءة",
    unread_many: "{{count}} غير مقروءة",
    unread_other: "{{count}} غير مقروءة",
    formSubmit: "إرسال",
    formSent: "تم الإرسال",
    timeline: "الخط الزمني",
    job: "مهمة",
    expand: "توسيع",
    collapse: "طي",
    postsWithComments_zero: "لا منشورات",
    postsWithComments_one: "منشور واحد مع تعليقاته",
    postsWithComments_two: "منشوران مع تعليقاتهما",
    postsWithComments_few: "{{count}} منشورات مع تعليقاتها",
    postsWithComments_many: "{{count}} منشورًا مع تعليقاتها",
    postsWithComments_other: "{{count}} منشور مع تعليقاته",
    allComments: "كل التعليقات",
    matching: "{{n}} مطابق",
    noMatching: "لا توجد تعليقات مطابقة على هذا المنشور.",
    showMore: "عرض المزيد",
    showLess: "عرض أقل",
    openPost: "فتح المنشور",
    peekPost: "نظرة سريعة",
    postComments_zero: "لا تعليقات",
    postComments_one: "تعليق واحد",
    postComments_two: "تعليقان",
    postComments_few: "{{count}} تعليقات",
    postComments_many: "{{count}} تعليقًا",
    postComments_other: "{{count}} تعليق",
    postLikes_zero: "لا إعجابات",
    postLikes_one: "إعجاب واحد",
    postLikes_two: "إعجابان",
    postLikes_few: "{{count}} إعجابات",
    postLikes_many: "{{count}} إعجابًا",
    postLikes_other: "{{count}} إعجاب",
    pinnedPair: "تم تثبيت المنشورات وتعليقاتها في {{name}} وتبقى محدّثة مباشرة.",
  },
  actions: {
    run: "تشغيل",
    open: "فتح",
    filter: "عرض",
  },
  proposals: {
    proposal: "اقتراح",
    review: "مراجعة",
    reviewTitle: "راجع قبل أي تغيير",
    items_zero: "{{count}} عنصر",
    items_one: "عنصر واحد",
    items_two: "عنصران",
    items_few: "{{count}} عناصر",
    items_many: "{{count}} عنصرًا",
    items_other: "{{count}} عنصر",
    selected_zero: "{{count}} من {{total}} محدد",
    selected_one: "{{count}} من {{total}} محدد",
    selected_two: "{{count}} من {{total}} محدد",
    selected_few: "{{count}} من {{total}} محدد",
    selected_many: "{{count}} من {{total}} محدد",
    selected_other: "{{count}} من {{total}} محدد",
    selectAll: "تحديد الكل",
    selectNone: "إلغاء التحديد",
    include: "تضمين {{what}}",
    approve_zero: "موافقة على {{count}}",
    approve_one: "موافقة على {{count}}",
    approve_two: "موافقة على {{count}}",
    approve_few: "موافقة على {{count}}",
    approve_many: "موافقة على {{count}}",
    approve_other: "موافقة على {{count}}",
    approveDanger_zero: "حذف {{count}} نهائيًا",
    approveDanger_one: "حذف {{count}} نهائيًا",
    approveDanger_two: "حذف {{count}} نهائيًا",
    approveDanger_few: "حذف {{count}} نهائيًا",
    approveDanger_many: "حذف {{count}} نهائيًا",
    approveDanger_other: "حذف {{count}} نهائيًا",
    reject: "رفض",
    rejected: "تم الرفض. لم يتغير شيء.",
    executing: "جارٍ التنفيذ…",
    done: "تم",
    summary: "{{ok}} تم · {{failed}} فشل · {{skipped}} تم تخطيه",
    undo: "تراجع",
    undone: "تم التراجع",
    undoFailed: "تعذّر التراجع.",
    agentNote: "يصوغ الوكيل رداً لكل عنصر. تنتظر كل مسودة في الموافقات: لا يُرسل شيء قبل أن يوافق عليه أحد.",
    undoing: "أوقف المهمة وأعيد العناصر التي غيّرتها…",
    undoJob: "مهمة التراجع",
    undoToast: "{{title}}: تم",
    edit: "نص الرد",
    editHint: "يمكنك تعديل النص قبل الموافقة.",
    blocked: "لا يمكن تنفيذه",
    reversible: "يمكنك التراجع لفترة بعد الموافقة.",
    irreversible: "لا يمكن التراجع عن هذا في إنستغرام.",
    execFailed: "تعذّر تنفيذ هذا الاقتراح.",
    expired: "انتهت صلاحية هذا الاقتراح. اسأل مرة أخرى.",
    statuses: {
      pending: "بانتظارك",
      executing: "قيد التنفيذ",
      executed: "تم",
      partially_executed: "تم جزئياً",
      failed: "فشل",
      rejected: "مرفوض",
      expired: "منتهي",
      undoing: "جارٍ التراجع…",
      undone: "تم التراجع",
    },
    kinds: {
      delete_comments: "حذف تعليقات",
      hide_comments: "إخفاء تعليقات",
      unhide_comments: "إظهار تعليقات",
      reply: "رد علني",
      private_reply: "رد خاص",
      send_message: "إرسال رسائل",
      flag: "وسم عناصر",
      archive: "أرشفة تعليقات",
      pin: "تثبيت تعليقات",
      mark_commenter: "تصنيف معلّقين",
      reload_comments: "إعادة تحميل التعليقات",
      resync_account: "مزامنة الحساب",
      create_rule: "إنشاء قاعدة",
      schedule_post: "جدولة منشور",
      agent_reply: "صياغة ردود بوكيل ذكي",
      assign: "إسناد إلى عضو في الفريق",
    },
  },
  suggestions: {
    negativeWeek: "اعرض التعليقات السلبية لهذا الأسبوع",
    spam: "أخفِ التعليقات المزعجة",
    bestTime: "متى أفضل وقت للنشر؟",
    topPost: "ما أفضل منشور أداءً هذا الشهر؟",
    deleted: "ما التعليقات التي حُذفت هذا الأسبوع؟",
    harmful: "من أكثر المعلّقين إساءة؟",
    postSpam: "أخفِ التعليقات المزعجة هنا",
    postSummary: "لخّص التعليقات على هذا المنشور",
    postReload: "أعد تحميل كل تعليقات هذا المنشور",
    inboxPrices: "اكتب ردوداً لأسئلة الأسعار التي بلا رد",
    inboxOpenDms: "أي الرسائل ما زالت نافذة الـ24 ساعة فيها مفتوحة؟",
    syncHealth: "هل فاتتنا أي تحديثات مباشرة؟",
    dashboardAdd: "أضف رسماً للتعليقات حسب المشاعر",
  },
};
